//

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { TauriService } from 'src/app/services/tauri/tauri.service';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { CBSYSLIBRE_SCHEMA } from '../@schemas/cbsyslibre.schema';
import { F_ARTCLIENT_SCHEMA } from '../@schemas/f_artclient.schema';
import { F_ARTCOMPTA_SCHEMA } from '../@schemas/f_artcompta.schema';
import { F_ARTENUMREF_SCHEMA } from '../@schemas/f_artenumref.schema';
import { F_ARTGAMME_SCHEMA } from '../@schemas/f_artgamme.schema';
import { F_ARTICLE_SCHEMA } from '../@schemas/f_article.schema';
import { F_ARTMODELE_SCHEMA } from '../@schemas/f_artmodele.schema';
import { F_CLIENT_SCHEMA } from '../@schemas/f_client.schema';
import { F_COLLABORATEUR_SCHEMA } from '../@schemas/f_collaborateur.schema';
import { F_COMPTEA_SCHEMA } from '../@schemas/f_comptea.schema';
import { F_CONDITION_SCHEMA } from '../@schemas/f_condition.schema';
import { F_DEPOT_SCHEMA } from '../@schemas/f_depot.schema';
import { F_FAMCLIENT_SCHEMA } from '../@schemas/f_famclient.schema';
import { F_FAMCOMPTA_SCHEMA } from '../@schemas/f_famcompta.schema';
import { F_FAMTARIF_SCHEMA } from '../@schemas/f_famtarif.schema';
import { F_FAMTARIFQTE_SCHEMA } from '../@schemas/f_famtarifqte.schema';
import { F_JOURNAUX_SCHEMA } from '../@schemas/f_journaux.schema';
import { F_MODELE_SCHEMA } from '../@schemas/f_modele.schema';
import { F_NOMENCLAT_SCHEMA } from '../@schemas/f_nomenclat.schema';
import { F_TARIF_SCHEMA } from '../@schemas/f_tarif.schema';
import { F_TARIFCOND_SCHEMA } from '../@schemas/f_tarifcond.schema';
import { F_TARIFGAM_SCHEMA } from '../@schemas/f_tarifgam.schema';
import { F_TARIFQTE_SCHEMA } from '../@schemas/f_tarifqte.schema';
import { F_TARIFSELECT_SCHEMA } from '../@schemas/f_tarifselect.schema';
import { F_TAXE_SCHEMA } from '../@schemas/f_taxe.schema';
import { FN_PARAMS_SCHEMA } from '../@schemas/fn_params.schema';
import { P_DEVICE_SCHEMA } from '../@schemas/p_device.schema';
import { P_DEVISE_SCHEMA } from '../@schemas/p_devise.schema';
import { P_DOSSIER_SCHEMA } from '../@schemas/p_dossier.schema';
import { P_MODELE_IMPRESSION_SCHEMA } from '../@schemas/p_modele_impression.schema';
import { P_PARAMS_SCHEMA } from '../@schemas/p_params.schema';
import { P_REGLEMENT_SCHEMA } from '../@schemas/p_reglement.schema';
import { P_SOUCHEVENTE_SCHEMA } from '../@schemas/p_souchevente';
import { PANEL_PARAMS_SCHEMA } from '../@schemas/panel_params.schema';
import { VX_PARAMS_SCHEMA } from '../@schemas/vx_params.schema';
import { RxPDeviceDocument } from '../@services/m-cashdesk-core-rxdb';
import { CluFeSnackbarService } from '../../@services/clufe-snackbar.service';
import { CashDeskCoreRxDbService } from '../@services/m-cashdesk-core-rxdb.service';
import { CashDeskZCluJetService } from '../@services/m-cashdesk-zclujet.service';
import { HubNotification, SignalRService } from 'src/app/services/signalr.service';
import { AuthService } from 'src/app/@auth/auth.service';
import { AuthUtils } from 'src/app/utils/auth.utils';

@Injectable({
  providedIn: 'root'
})
export class ConnectorCashDeskSyncDownDaoService {
  processInError = false;
  syncParams : any;
  currentDevices : RxPDeviceDocument[] = [];
  private _initialSyncSteps: any[] = [
    { INDEX : 0, CODE : 'GETDATA', STATUS : 'pending', TITLE : 'Récupération des données du serveur', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 1, CODE : 'CLEANUP', STATUS : 'pending', TITLE : 'Nettoyage des données existantes', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 2, CODE : 'BULKINSERT_PARAMS', STATUS : 'pending', TITLE : 'Données embarquées : Paramètres', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 3, CODE : 'BULKINSERT_FNPARAMS', STATUS : 'pending', TITLE : 'Données embarquées : Fonctions & Options', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 4, CODE : 'BULKINSERT_PANELPARAMS', STATUS : 'pending', TITLE : 'Données embarquées : Panneaux', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 5, CODE : 'BULKINSERT_DEVICES', STATUS : 'pending', TITLE : 'Données embarquées : Caisses', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 6, CODE : 'BULKINSERT_DEVISES', STATUS : 'pending', TITLE : 'Données embarquées : Devises', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 7, CODE : 'BULKINSERT_REGLEMENTS', STATUS : 'pending', TITLE : 'Données embarquées : Modes règlement', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 8, CODE : 'BULKINSERT_CLIENTS', STATUS : 'pending', TITLE : 'Données embarquées : Clients', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 9, CODE : 'BULKINSERT_COMPTEA', STATUS : 'pending', TITLE : 'Données embarquées : Sections Analytique', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 10, CODE : 'BULKINSERT_ARTICLES', STATUS : 'pending', TITLE : 'Données embarquées : Articles', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 11, CODE : 'BULKINSERT_DEPOTS', STATUS : 'pending', TITLE : 'Données embarquées : Dépôts', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 12, CODE : 'BULKINSERT_COLLABORATEURS', STATUS : 'pending', TITLE : 'Données embarquées : Collaborateurs', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 13, CODE : 'BULKINSERT_ARTGAMMES', STATUS : 'pending', TITLE : 'Données embarquées : Gammes', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 14, CODE : 'BULKINSERT_ARTENUMREFS', STATUS : 'pending', TITLE : 'Données embarquées : Gammes / Infos', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 15, CODE : 'BULKINSERT_TARIFGAMS', STATUS : 'pending', TITLE : 'Données embarquées : Gammes / Tarifs', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 16, CODE : 'BULKINSERT_NOMENCLATURES', STATUS : 'pending', TITLE : 'Données embarquées : Nomenclatures', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 17, CODE : 'BULKINSERT_SPECTARIFS', STATUS : 'pending', TITLE : 'Données embarquées : Spécificités tarifaires', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 18, CODE : 'BULKINSERT_TARIFQTES', STATUS : 'pending', TITLE : 'Données embarquées : Spécificités tarifaires / paliers', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 19, CODE : 'BULKINSERT_CONDITIONS', STATUS : 'pending', TITLE : 'Données embarquées : Conditionnement', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 20, CODE : 'BULKINSERT_TAXES', STATUS : 'pending', TITLE : 'Données embarquées : Taxes', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 21, CODE : 'BULKINSERT_TARIFS', STATUS : 'pending', TITLE : 'Données embarquées : Tarifs [Barêmes/Promotions]', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 22, CODE : 'BULKINSERT_TARIFSELECTS', STATUS : 'pending', TITLE : 'Données embarquées : Tarifs Select [Barêmes/Promotions]', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 23, CODE : 'BULKINSERT_MODELES_IMPRESSION', STATUS : 'pending', TITLE : 'Données embarquées : Modèles impression', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 24, CODE : 'BULKINSERT_TARIFCONDS', STATUS : 'pending', TITLE : 'Données embarquées : Spécificités tarifaires / Conditionnement', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 25, CODE : 'BULKINSERT_PDOSSIER', STATUS : 'pending', TITLE : 'Données embarquées : Infos Société', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 26, CODE : 'BULKINSERT_CHAMPSLIBRE', STATUS : 'pending', TITLE : 'Données embarquées : Champs Libre', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 27, CODE : 'BULKINSERT_MODELES', STATUS : 'pending', TITLE : 'Données embarquées : Modèles enregistrements', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 28, CODE : 'BULKINSERT_ARTMODELES', STATUS : 'pending', TITLE : 'Données embarquées : Modèles enregistrements / Cibles', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 29, CODE : 'BULKINSERT_SOUCHESVENTE', STATUS : 'pending', TITLE : 'Données embarquées : Souches vente', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 30, CODE : 'BULKINSERT_JOURNAUX', STATUS : 'pending', TITLE : 'Données embarquées : Journaux', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 31, CODE : 'BULKINSERT_VXPARAMS', STATUS : 'pending', TITLE : 'Données embarquées : Compléments', START : undefined, END : undefined, DURATION : undefined },
    { INDEX : 32, CODE : 'FINALIZE', STATUS : 'pending', TITLE : 'Finalisation synchronisation', START : undefined, END : undefined, DURATION : undefined },
  ];

  syncSteps : any[] = [];
  syncStepsObs$ = new BehaviorSubject<any[]>([]);
  syncLastDate: Date | null = null;

  remoteSyncStepsObs$ = new BehaviorSubject<any[]>([]);

  private _emitTimeout: any = null;
  private _emitDelayMs = 50; // debounce window in ms

  private scheduleEmit() {
    if (this._emitTimeout) { return; }
    this._emitTimeout = setTimeout(() => {
      this._emitTimeout = null;
      try { this.syncStepsObs$.next(this.syncSteps.map((s: any) => ({ ...s }))); } catch (e) {}
    }, this._emitDelayMs);
  }

  private emitNow() {
    if (this._emitTimeout) { clearTimeout(this._emitTimeout); this._emitTimeout = null; }
    try { this.syncStepsObs$.next(this.syncSteps.map((s: any) => ({ ...s }))); } catch (e) {}
  }

  private makeObservableStep(step: any) {
    const self = this;
    return new Proxy(step, {
      set(target: any, prop: string | symbol, value: any) {
        target[prop as any] = value;
        try { self.scheduleEmit(); } catch (e) {}
        return true;
      }
    });
  }

  constructor(
      private httpClient: HttpClient,
      private apiService: ApiService,
      private _cashDeskRxDbService : CashDeskCoreRxDbService,
      private _cashDeskZCluJetService : CashDeskZCluJetService,
      private _snackBarService : CluFeSnackbarService,
      private tauriService: TauriService,
      private signalRService: SignalRService,
      private _authService: AuthService,
  ) {
    // initialize proxied observable steps
    this.syncSteps = this._initialSyncSteps.map(s => this.makeObservableStep({ ...s }));
    if (this.tauriService.isTauri) {
      this.syncSteps.splice(1, 0, this.makeObservableStep({ INDEX : 99, CODE : 'SYNCDATA_POS', STATUS : 'pending', TITLE : 'Synchronisation des données du POS', START : undefined, END : undefined, DURATION : undefined }));
    }

    this.signalRService.notificationHub$.subscribe((notification: HubNotification) => {
      const remoteSyncSteps = this.remoteSyncStepsObs$.value;
      remoteSyncSteps.push(JSON.parse(notification.NOTIFICATION_DATAS));
      this.remoteSyncStepsObs$.next(remoteSyncSteps);
    });

    // emit initial snapshot
    this.emitNow();
  }

  doGetCashDeskSyncParamsAction_Sync(){
      let _httpParams = new HttpParams();
      return this.httpClient.get(this.apiService.endPointsFO.doGetCashDeskSyncParamsAction_Sync, { params : _httpParams});
  }

  async runCashDeskSyncDown() {
    const authSession = this._authService.AuthSession;  
    if (!this.signalRService.isConnected() && authSession && !AuthUtils.isTokenExpired(authSession.AccessToken)) { this.signalRService.doConnectHub().then(() => this.signalRService.authenticate(authSession.AccessToken)); }

    this.syncSteps.forEach(s=> {
      s.STATUS = 'pending';
      s.END = undefined;
      s.DURATION = undefined;
      s.ERROR = false;
      s.ERROR_MESSAGE = undefined;
    });
    this.remoteSyncStepsObs$.next([]);

    await this.runAction_GETDATA();

    //
    if (this.tauriService.isTauri) {
      let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'SYNCDATA_POS');
      STEP_ITEM.STATUS = 'inprogress';
      STEP_ITEM.START = new Date();
      try {
        await lastValueFrom(this.tauriService.doRunCashdeskSyncDownAction(this.syncParams));
        STEP_ITEM.STATUS = 'completed_success';
        STEP_ITEM.END = new Date();
        STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
      } catch(err: any) {
        this.processInError = true;
        STEP_ITEM.STATUS = 'completed_error';
        STEP_ITEM.ERROR = true;
        STEP_ITEM.ERROR_MESSAGE = err;
        console.log(err);
        this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
      } finally {
        STEP_ITEM.END = new Date();
        STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
      }
    }
    //

    await this._cashDeskZCluJetService.doLogCashDeskSyncEvent_JetFn();
    await this.runAction_CLEANUP();
    await this.runAction_BULKINSERT_PARAMS();
    await this.runAction_BULKINSERT_FNPARAMS();
    await this.runAction_BULKINSERT_PANELPARAMS();
    await this.runAction_BULKINSERT_DEVICES();
    await this.runAction_BULKINSERT_DEVISES();
    await this.runAction_BULKINSERT_REGLEMENTS();
    await this.runAction_BULKINSERT_CLIENTS();
    await this.runAction_BULKINSERT_COMPTEA();
    await this.runAction_BULKINSERT_ARTICLES();
    await this.runAction_BULKINSERT_DEPOTS();
    await this.runAction_BULKINSERT_COLLABORATEURS();
    await this.runAction_BULKINSERT_ARTGAMMES();
    await this.runAction_BULKINSERT_ARTENUMREFS();
    await this.runAction_BULKINSERT_TARIFGAMS();
    await this.runAction_BULKINSERT_NOMENCLATURES();
    await this.runAction_BULKINSERT_SPECTARIFS();
    await this.runAction_BULKINSERT_TARIFQTES();
    await this.runAction_BULKINSERT_CONDITIONS();
    await this.runAction_BULKINSERT_TARIFCONDS();
    await this.runAction_BULKINSERT_TAXES();
    await this.runAction_BULKINSERT_TARIFS();
    await this.runAction_BULKINSERT_TARIFSELECTS();
    await this.runAction_BULKINSERT_MODELES_IMPRESSION();
    await this.runAction_BULKINSERT_PDOSSIER();
    await this.runAction_BULKINSERT_CHAMPSLIBRE();
    await this.runAction_BULKINSERT_MODELES();
    await this.runAction_BULKINSERT_ARTMODELES();
    await this.runAction_BULKINSERT_SOUCHESVENTE();
    await this.runAction_BULKINSERT_JOURNAUX();
    await this.runAction_BULKINSERT_VXPARAMS();
    await this.runAction_FINALIZE();
  }

  private async runAction_GETDATA() {
    //if(this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'GETDATA');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();

    try {
      this.syncParams = await lastValueFrom(this.doGetCashDeskSyncParamsAction_Sync());
      if(!this.syncParams) { throw new Error('Les données provenant du serveur n\'ont pas pu être récupérées.'); }
      //console.log(this.syncParams);
      STEP_ITEM.STATUS = 'completed_success';
      STEP_ITEM.END = new Date();
      STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
    }
    catch (err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.END = new Date();
      STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err && err.error &&  err.error.Message ? err.error.Message : 'Plus de détails dans la console';
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
      console.error(err);
    }
  }

  CAISSESESSION_REAFF : any = {};
  private async runAction_CLEANUP(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'CLEANUP');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    // #region SET LOCALGID IF DIFFERENT FROM LOCAL
    /**
     * La méthodologie est la suivante : Le back ramène les LOCALGID, on parcourt et on les vide seulement s'ils sont différents en local
     */
    let DEVICES_LOCALGID : any | undefined = undefined;
    try {
      DEVICES_LOCALGID = undefined;//this.getSessionStorage_DEVICES_LOCALGID();
      if (this.tauriService.isTauri) {
        this.currentDevices = await this.tauriService.doGetPDeviceItemsAction({});
      } else {
        const query_DEVICE = this._cashDeskRxDbService.db.pdevice.find({ selector: { }, sort: [] });
        this.currentDevices = await query_DEVICE.exec();
      }
    }
    catch(err) { }
    try {
      if(DEVICES_LOCALGID) {
        this.syncParams.DEVICES.forEach((dItem : RxPDeviceDocument) => {
          let _mLOCALGID = DEVICES_LOCALGID[dItem.CAISSE_SESSION!];
          if(_mLOCALGID && _mLOCALGID != dItem.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID) { dItem.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID = null; this.CAISSESESSION_REAFF[dItem.CAISSE_SESSION!] = true; }
        });
      }
      else {
        this.syncParams.DEVICES.forEach((dItem : RxPDeviceDocument) => {
          if(dItem.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID){
            let _m = this.currentDevices.find((cItem : any) => dItem.CAISSE_SESSION == cItem.CAISSE_SESSION);
            if(!_m || _m.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID != dItem.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID) { dItem.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID = null; this.CAISSESESSION_REAFF[dItem.CAISSE_SESSION!] = true; }
          }
        });
      }
    }
    catch(err) {

    }
    // #endregion
    try {
      await this._cashDeskRxDbService.db.pparams.remove(); await this._cashDeskRxDbService.db.addCollections({ ['pparams'] : { schema: P_PARAMS_SCHEMA,
        migrationStrategies: {
            // 1 means, this transforms data from version 0 to version 1
            1: (oldDoc : any) => { oldDoc.DISPLAY_DEVICE_MESSAGES = null; return oldDoc; },
            2: (oldDoc : any) => { return oldDoc; },
        } } });
      await this._cashDeskRxDbService.db.fnparams.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fnparams'] : { schema: FN_PARAMS_SCHEMA,
        migrationStrategies: {
            // 1 means, this transforms data from version 0 to version 1
            1: (oldDoc : any) => { oldDoc.FN_REMISEG_ENABLED = false; oldDoc.FN_REMISEG_PARAMS = undefined; return oldDoc; },
            2: (oldDoc : any) => { oldDoc.FN_FOND_CAISSE_ENABLED = false; oldDoc.FN_FOND_CAISSE_PARAMS = undefined; return oldDoc; },
            3: (oldDoc : any) => { oldDoc.FN_MVTS_CAISSE_ENABLED = false; oldDoc.FN_MVTS_CAISSE_PARAMS = undefined; return oldDoc; },
            4: (oldDoc : any) => { oldDoc.FN_RETOURS_ENABLED = false; oldDoc.FN_RETOURS_PARAMS = undefined; return oldDoc; },
            5: (oldDoc : any) => { oldDoc.FN_CARTECADEAUX_ENABLED = false; oldDoc.FN_CARTECADEAUX_PARAMS = undefined; return oldDoc; },
            6: (oldDoc : any) => { oldDoc.FN_CASHOPTS_ENABLED = false; oldDoc.FN_CASHOPTS_PARAMS = undefined; return oldDoc; },
            7: (oldDoc : any) => { oldDoc.FN_BALANCES_ENABLED = false; oldDoc.FN_BALANCES_PARAMS = undefined; return oldDoc; },
            8: (oldDoc : any) => { oldDoc.FN_MODIFPRIX_ENABLED = false; oldDoc.FN_MODIFPRIX_PARAMS = undefined; return oldDoc; },
            9: (oldDoc : any) => { oldDoc.FN_QTENEG_ENABLED = false; oldDoc.FN_QTENEG_PARAMS = undefined; return oldDoc; }
        } } });
      await this._cashDeskRxDbService.db.vxparams.remove(); await this._cashDeskRxDbService.db.addCollections({ ['vxparams'] : { schema: VX_PARAMS_SCHEMA } });
      await this._cashDeskRxDbService.db.panelparams.remove(); await this._cashDeskRxDbService.db.addCollections({ ['panelparams'] : { schema: PANEL_PARAMS_SCHEMA } });

      if (this.tauriService.isTauri) {
        await this.tauriService.doDeleteAllPDeviceItemsAction();
      }// else {
        await this._cashDeskRxDbService.db.pdevice.remove(); await this._cashDeskRxDbService.db.addCollections({ ['pdevice'] : { schema: P_DEVICE_SCHEMA,
          migrationStrategies: {
            1: (oldDoc : any) => { oldDoc.CAISSE_SESSION_OUVERTURE_FOND_CAISSE = 0; oldDoc.CAISSE_SESSION_CLOTURE_SOLDE_THEORIQUE = 0; oldDoc.CAISSE_SESSION_CLOTURE_SOLDE_CAISSE = 0; oldDoc.CAISSE_SESSION_CLOTURE_SOLDE_ECART = 0; return oldDoc; },
            2: (oldDoc : any) => { oldDoc.C_SUPERVISEURS_IDS = ''; oldDoc.DEVICES_SUPERVISEURS = ''; return oldDoc; },
            3: (oldDoc : any) => { oldDoc.C_DO_SOUCHE = 0; return oldDoc; },
            4: (oldDoc : any) => { oldDoc.CAISSE_SESSION_OFFLINE_TRRSA_PK = null; return oldDoc; },
            5: (oldDoc : any) => { oldDoc.LASTSEQ_TICKET = null; oldDoc.LASTSEQ_DUPLICATA = null; return oldDoc; },
            6: (oldDoc : any) => { oldDoc.C_N_ANALYTIQUE = 0; oldDoc.C_CA_NUM = ''; return oldDoc; },
            7: (oldDoc : any) => { oldDoc.C_CO_NO_MODE = 0; oldDoc.C_CO_NO = 0; return oldDoc; },
            8: (oldDoc : any) => { oldDoc.CLU_AGENT_REQUIRED = false; return oldDoc; },
            9: (oldDoc : any) => { oldDoc.SESSION_TEST_ENV = false; oldDoc.SESSION_TEST_CODE = ''; return oldDoc; },
            10: (oldDoc : any) => { oldDoc.RUN_ONLY_ON_DEVICE = false; oldDoc.DEVICE_ID_ALLOWED = ''; return oldDoc; },
            11: (oldDoc : any) => { oldDoc.CAISSE_SESSION_OUVERTURE_FH_UTC = null; oldDoc.CAISSE_SESSION_CLOTURE_FH_UTC = null; return oldDoc; },
            12: (oldDoc : any) => { return oldDoc; },
            13: (oldDoc : any) => { oldDoc.CLOTURE_SOLDE_FOND_CAISSE = null; oldDoc.CLOTURE_DECOMPTE_FOND_CAISSE_ITEMS = null; return oldDoc; }
          } }
          });
      //}
      await this._cashDeskRxDbService.db.pdevise.remove(); await this._cashDeskRxDbService.db.addCollections({ ['pdevise'] : { schema: P_DEVISE_SCHEMA } });
      await this._cashDeskRxDbService.db.preglement.remove(); await this._cashDeskRxDbService.db.addCollections({ ['preglement'] : { schema: P_REGLEMENT_SCHEMA, migrationStrategies: { 1: (oldDoc : any) => { oldDoc.ZCD_P_DEVISE_ACCEPTED = 0; return oldDoc; }, 2: (oldDoc : any) => { oldDoc.R_MORE_PARAMS = ''; return oldDoc; }, 3: (oldDoc : any) => { oldDoc.SCD_TYPE = 0; oldDoc.JO_NUMCLI = ''; oldDoc.JO_NUMFOUR = ''; return oldDoc; } } } });
      await this._cashDeskRxDbService.db.fclient.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fclient'] : { schema: F_CLIENT_SCHEMA,
        migrationStrategies: { 1: (oldDoc : any) => { oldDoc.N_DEVISE = 0; oldDoc.N_DEVISELIB = ''; oldDoc.CT_IDENTIFIANT = ''; oldDoc.CT_APE = ''; oldDoc.CT_TELEPHONE = '';
                                                      oldDoc.CT_EMAIL = ''; oldDoc.CT_ADRESSE = ''; oldDoc.CT_COMPLEMENT = ''; oldDoc.CT_VILLE = ''; oldDoc.CT_PAYS = ''; oldDoc.CT_CODEPOSTAL = ''; oldDoc.CT_CODEREGION = '';
                                                      oldDoc.N_DEVISE_COURS = 0; oldDoc.N_DEVISE_FORMAT = ''; return oldDoc; },
                                2: (oldDoc : any) => { oldDoc.CT_TAUX01 = 0; return oldDoc; },
                                3: (oldDoc : any) => { oldDoc.CT_CONTACT = ''; oldDoc.CT_TELECOPIE = ''; oldDoc.CT_COMMENTAIRE = ''; oldDoc.CT_SITE = ''; oldDoc.CT_LINKEDIN = '';
                                                      oldDoc.CT_FACEBOOK = ''; oldDoc.CONTACT_ITEMS_JSON = ''; oldDoc.ADRESSE_ITEMS_JSON = ''; return oldDoc; },
                                4: (oldDoc : any) => { oldDoc.EXTRA = ''; return oldDoc; },
                                5: (oldDoc : any) => { oldDoc.CO_NO = 0; oldDoc.CO_NOLIB = ''; return oldDoc; },
                                6: (oldDoc : any) => { oldDoc.CT_QUALITE = ''; return oldDoc; },
                                7: (oldDoc : any) => { oldDoc.CT_NUMPAYEUR = oldDoc.CT_NUM; return oldDoc; },
                                8: (oldDoc : any) => { oldDoc.CA_NUM = null; return oldDoc; } } } });
      await this._cashDeskRxDbService.db.farticle.remove(); await this._cashDeskRxDbService.db.addCollections({ ['farticle'] : { schema: F_ARTICLE_SCHEMA,
        migrationStrategies: { 1: (oldDoc : any) => { oldDoc.ARTSTOCK_ITEMS_JSON = '';  oldDoc.ARTVTECLU_ITEMS_JSON = ''; oldDoc.AR_SUIVISTOCKLIB = '';
                                                      oldDoc.ARTSTOCK_TOT = 0; oldDoc.ARTVTECLU_TOT = 0; oldDoc.STOCKESTIME_TOT = 0; return oldDoc; },
                                2: (oldDoc : any) => { oldDoc.HGLT_IS_IMG = false; oldDoc.HGLT_IMG_DATA = ''; return oldDoc; },
                                3: (oldDoc : any) => { oldDoc.EXTRA = ''; return oldDoc; },
                                4: (oldDoc : any) => { oldDoc.AR_NOTIMP = 0; return oldDoc; },
                                5: (oldDoc : any) => { oldDoc.AR_FACTPOIDS = 0; oldDoc.AR_POIDSNET = 0; oldDoc.AR_POIDSBRUT = 0; return oldDoc; } } } });
      await this._cashDeskRxDbService.db.fdepot.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fdepot'] : { schema: F_DEPOT_SCHEMA } });
      await this._cashDeskRxDbService.db.fcollaborateur.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fcollaborateur'] : { schema: F_COLLABORATEUR_SCHEMA } });
      await this._cashDeskRxDbService.db.fcomptea.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fcomptea'] : { schema: F_COMPTEA_SCHEMA,
        migrationStrategies: { 1: (oldDoc : any) => { oldDoc.CA_NUM_PK = oldDoc.N_ANALYTIQUE + '_' + oldDoc.CA_NUM; return oldDoc; },
                                2: (oldDoc : any) => { oldDoc.IS_AFFAIRE = 0; return oldDoc; } } } });
      await this._cashDeskRxDbService.db.fartgamme.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fartgamme'] : { schema: F_ARTGAMME_SCHEMA } });
      await this._cashDeskRxDbService.db.fartenumref.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fartenumref'] : { schema: F_ARTENUMREF_SCHEMA } });
      await this._cashDeskRxDbService.db.ftarifgam.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ftarifgam'] : { schema: F_TARIFGAM_SCHEMA } });
      await this._cashDeskRxDbService.db.ftarifqte.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ftarifqte'] : { schema: F_TARIFQTE_SCHEMA } });
      await this._cashDeskRxDbService.db.ftarifcond.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ftarifcond'] : { schema: F_TARIFCOND_SCHEMA } });
      await this._cashDeskRxDbService.db.fartclient.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fartclient'] : { schema: F_ARTCLIENT_SCHEMA, migrationStrategies: { 1: (oldDoc : any) => { oldDoc.AC_QTEMONT = 0; return oldDoc; } } } });
      await this._cashDeskRxDbService.db.fartcompta.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fartcompta'] : { schema: F_ARTCOMPTA_SCHEMA } });
      await this._cashDeskRxDbService.db.ffamcompta.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ffamcompta'] : { schema: F_FAMCOMPTA_SCHEMA } });
      await this._cashDeskRxDbService.db.ffamclient.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ffamclient'] : { schema: F_FAMCLIENT_SCHEMA } });
      await this._cashDeskRxDbService.db.ffamtarif.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ffamtarif'] : { schema: F_FAMTARIF_SCHEMA } });
      await this._cashDeskRxDbService.db.ffamtarifqte.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ffamtarifqte'] : { schema: F_FAMTARIFQTE_SCHEMA } });
      await this._cashDeskRxDbService.db.fnomenclature.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fnomenclature'] : { schema: F_NOMENCLAT_SCHEMA } });
      await this._cashDeskRxDbService.db.fcondition.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fcondition'] : { schema: F_CONDITION_SCHEMA } });
      await this._cashDeskRxDbService.db.pmodeleimpression.remove(); await this._cashDeskRxDbService.db.addCollections({ ['pmodeleimpression'] : { schema: P_MODELE_IMPRESSION_SCHEMA, migrationStrategies: {
        1: (oldDoc : any) => { oldDoc.TYPE_MODELE_IMPRESSION = 1; return oldDoc; },
        2: (oldDoc : any) => { oldDoc.IMPORT_ID = null; return oldDoc; },
      } } });
      await this._cashDeskRxDbService.db.pdossier.remove(); await this._cashDeskRxDbService.db.addCollections({ ['pdossier'] : { schema: P_DOSSIER_SCHEMA,
        migrationStrategies: {
          1: (oldDoc : any) => { oldDoc.D_SIRET = ''; oldDoc.D_APE = ''; oldDoc.D_IDENTIFIANT = ''; return oldDoc; },
          2 : (oldDoc : any) => { oldDoc.D_RCS = ''; return oldDoc; }
        } } });
      await this._cashDeskRxDbService.db.cbsyslibre.remove(); await this._cashDeskRxDbService.db.addCollections({ ['cbsyslibre'] : { schema: CBSYSLIBRE_SCHEMA } });
      await this._cashDeskRxDbService.db.fmodele.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fmodele'] : { schema: F_MODELE_SCHEMA } });
      await this._cashDeskRxDbService.db.fartmodele.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fartmodele'] : { schema: F_ARTMODELE_SCHEMA } });
      await this._cashDeskRxDbService.db.psouchevente.remove(); await this._cashDeskRxDbService.db.addCollections({ ['psouchevente'] : { schema: P_SOUCHEVENTE_SCHEMA } });
      await this._cashDeskRxDbService.db.ftaxe.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ftaxe'] : { schema: F_TAXE_SCHEMA } });
      await this._cashDeskRxDbService.db.ftarif.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ftarif'] : { schema: F_TARIF_SCHEMA } });
      await this._cashDeskRxDbService.db.ftarifselect.remove(); await this._cashDeskRxDbService.db.addCollections({ ['ftarifselect'] : { schema: F_TARIFSELECT_SCHEMA } });
      await this._cashDeskRxDbService.db.fjournaux.remove(); await this._cashDeskRxDbService.db.addCollections({ ['fjournaux'] : { schema: F_JOURNAUX_SCHEMA } });
      STEP_ITEM.STATUS = 'completed_success';

    } catch (err: any) {
        STEP_ITEM.STATUS = 'completed_error';
        console.log(err);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_PARAMS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_PARAMS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.PARAMS ? 1 : 0;
    try {
      if (!!this.syncParams.PARAMS.DISPLAY_DEVICE_MESSAGES) {
        try { this.syncParams.PARAMS.DISPLAY_DEVICE_MESSAGES = JSON.stringify(this.syncParams.PARAMS.DISPLAY_DEVICE_MESSAGES); } catch { this.syncParams.PARAMS.DISPLAY_DEVICE_MESSAGES = []; }
      }
      await this._cashDeskRxDbService.db.pparams.bulkInsert([this.syncParams.PARAMS]).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.pparams.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_FNPARAMS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_FNPARAMS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.FN_PARAMS ? 1 : 0;
    try {
      let _fnParams = this.syncParams.FN_PARAMS;
      let _fnParamsKeys = Object.keys(_fnParams);
      _fnParamsKeys.forEach(key => {
        if(key.endsWith('_PARAMS'))
        {
          _fnParams[key] = JSON.stringify(_fnParams[key]);
        }
      });
      await this._cashDeskRxDbService.db.fnparams.bulkInsert([_fnParams]).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fnparams.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_PANELPARAMS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_PANELPARAMS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.PANELS ? this.syncParams.PANELS.length : 0;
    try {
      await this._cashDeskRxDbService.db.panelparams.bulkInsert(this.syncParams.PANELS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.panelparams.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_DEVICES(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_DEVICES');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.DEVICES ? this.syncParams.DEVICES.length : 0;
    try {
      this.syncParams.DEVICES.forEach((device: any) => {
        try { device.C_SUPERVISEURS_IDS = JSON.stringify(device.C_SUPERVISEURS_IDS); } catch {}
        try { device.DEVICES_SUPERVISEURS = JSON.stringify(device.DEVICES_SUPERVISEURS); } catch {}
        try { device.CLOTURE_DECOMPTE_FOND_CAISSE_ITEMS = JSON.stringify(device.CLOTURE_DECOMPTE_FOND_CAISSE_ITEMS); } catch {}
      });
      if (this.tauriService.isTauri) {
        await this.tauriService.doSyncPDeviceItemAction(this.syncParams.DEVICES);
      }// else {
        await this._cashDeskRxDbService.db.pdevice.bulkInsert(this.syncParams.DEVICES).then((v) => {
          console.log(v);
          if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
          else { this.setSessionStorage_DEVICES_LOCALGID(this.syncParams.DEVICES);}
        });
        await this._cashDeskRxDbService.db.pdevice.exportJSON().then((json : any) => {});
      //}
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_DEVISES(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_DEVISES');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.DEVISES ? this.syncParams.DEVISES.length : 0;
    try {
      await this._cashDeskRxDbService.db.pdevise.bulkInsert(this.syncParams.DEVISES).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.pdevise.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_REGLEMENTS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_REGLEMENTS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.MREGLEMENTS ? this.syncParams.MREGLEMENTS.length : 0;
    try {
      await this._cashDeskRxDbService.db.preglement.bulkInsert(this.syncParams.MREGLEMENTS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.preglement.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_CLIENTS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_CLIENTS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.CLIENTS ? this.syncParams.CLIENTS.length : 0;
    try {
      this.syncParams.CLIENTS.forEach((m : any) => {
        m.CONTACT_ITEMS_JSON = JSON.stringify(m.F_CONTACTT_ITEMS);
        m.ADRESSE_ITEMS_JSON = JSON.stringify(m.F_LIVRAISON_ITEMS);
        delete m.F_CONTACTT_ITEMS;
        delete m.F_LIVRAISON_ITEMS;
      });
      await this._cashDeskRxDbService.db.fclient.bulkInsert(this.syncParams.CLIENTS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fclient.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_COMPTEA(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_COMPTEA');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.COMPTEAS ? this.syncParams.COMPTEAS.length : 0;
    try {
      await this._cashDeskRxDbService.db.fcomptea.bulkInsert(this.syncParams.COMPTEAS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fcomptea.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_ARTICLES(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_ARTICLES');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.ARTICLES ? this.syncParams.ARTICLES.length : 0;
    try {
      await this._cashDeskRxDbService.db.farticle.bulkInsert(this.syncParams.ARTICLES).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.farticle.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_DEPOTS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_DEPOTS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.DEPOTS ? this.syncParams.DEPOTS.length : 0;
    try {
      await this._cashDeskRxDbService.db.fdepot.bulkInsert(this.syncParams.DEPOTS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fdepot.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_COLLABORATEURS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_COLLABORATEURS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.COLLABORATEURS ? this.syncParams.COLLABORATEURS.length : 0;
    try {
      await this._cashDeskRxDbService.db.fcollaborateur.bulkInsert(this.syncParams.COLLABORATEURS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fcollaborateur.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_ARTGAMMES(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_ARTGAMMES');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.ARTGAMMES ? this.syncParams.ARTGAMMES.length : 0;
    try {
      await this._cashDeskRxDbService.db.fartgamme.bulkInsert(this.syncParams.ARTGAMMES).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fartgamme.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_ARTENUMREFS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_ARTENUMREFS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.ARTENUMREFS ? this.syncParams.ARTENUMREFS.length : 0;
    try {
      await this._cashDeskRxDbService.db.fartenumref.bulkInsert(this.syncParams.ARTENUMREFS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fartenumref.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_TARIFGAMS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_TARIFGAMS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.TARIFGAMS ? this.syncParams.TARIFGAMS.length : 0;
    try {
      await this._cashDeskRxDbService.db.ftarifgam.bulkInsert(this.syncParams.TARIFGAMS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ftarifgam.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_NOMENCLATURES(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_NOMENCLATURES');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.NOMENCLATURES ? this.syncParams.NOMENCLATURES.length : 0;
    try {
      await this._cashDeskRxDbService.db.fnomenclature.bulkInsert(this.syncParams.NOMENCLATURES).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fnomenclature.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_CONDITIONS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_CONDITIONS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.CONDITIONS ? this.syncParams.CONDITIONS.length : 0;
    try {
      await this._cashDeskRxDbService.db.fcondition.bulkInsert(this.syncParams.CONDITIONS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fcondition.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_SPECTARIFS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_SPECTARIFS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    try {
      await this._cashDeskRxDbService.db.fartclient.bulkInsert(this.syncParams.ARTCLIENTS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fartclient.exportJSON().then((json : any) => {});
      await this._cashDeskRxDbService.db.ffamclient.bulkInsert(this.syncParams.FAMCLIENTS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ffamclient.exportJSON().then((json : any) => {});
      await this._cashDeskRxDbService.db.ffamtarif.bulkInsert(this.syncParams.FAMTARIFS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ffamtarif.exportJSON().then((json : any) => {});
      await this._cashDeskRxDbService.db.ffamtarifqte.bulkInsert(this.syncParams.FAMTARIFQTES).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ffamtarifqte.exportJSON().then((json : any) => {});

      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_TARIFQTES(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_TARIFQTES');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.TARIFQTES ? this.syncParams.TARIFQTES.length : 0;
    try {
      await this._cashDeskRxDbService.db.ftarifqte.bulkInsert(this.syncParams.TARIFQTES).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ftarifqte.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_TARIFCONDS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_TARIFCONDS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.TARIFCONDS ? this.syncParams.TARIFCONDS.length : 0;
    try {
      await this._cashDeskRxDbService.db.ftarifcond.bulkInsert(this.syncParams.TARIFCONDS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ftarifcond.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_TAXES(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_TAXES');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.ARTCOMPTAS ? this.syncParams.ARTCOMPTAS.length : 0;
    try {
      await this._cashDeskRxDbService.db.ftaxe.bulkInsert(this.syncParams.TAXES).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ftaxe.exportJSON().then((json : any) => {});

      await this._cashDeskRxDbService.db.fartcompta.bulkInsert(this.syncParams.ARTCOMPTAS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fartcompta.exportJSON().then((json : any) => {});

      await this._cashDeskRxDbService.db.ffamcompta.bulkInsert(this.syncParams.FAMCOMPTAS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ffamcompta.exportJSON().then((json : any) => {});

      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_TARIFS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_TARIFS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.TARIFS ? this.syncParams.TARIFS.length : 0;
    try {
      await this._cashDeskRxDbService.db.ftarif.bulkInsert(this.syncParams.TARIFS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ftarif.exportJSON().then((json : any) => {});

      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_TARIFSELECTS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_TARIFSELECTS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.TARIFSELECTS ? this.syncParams.TARIFSELECTS.length : 0;
    try {
      await this._cashDeskRxDbService.db.ftarifselect.bulkInsert(this.syncParams.TARIFSELECTS).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.ftarifselect.exportJSON().then((json : any) => {});

      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_MODELES_IMPRESSION(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_MODELES_IMPRESSION');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.MODELES_IMPRESSION ? this.syncParams.MODELES_IMPRESSION.length : 0;
    try {
      if (!!this.syncParams.MODELES_IMPRESSION) {
        for (var i = 0; i < this.syncParams.MODELES_IMPRESSION.length; i++) {
          if (!!this.syncParams.MODELES_IMPRESSION[i].PARAMS_MODELE) {
            this.syncParams.MODELES_IMPRESSION[i].PARAMS_MODELE = JSON.stringify(this.syncParams.MODELES_IMPRESSION[i].PARAMS_MODELE);
          } else {
            this.syncParams.MODELES_IMPRESSION[i].PARAMS_MODELE = '';
          }
          this.syncParams.MODELES_IMPRESSION[i].SOMMEIL = this.syncParams.MODELES_IMPRESSION[i].SOMMEIL == true ? 1 : 0;
          this.syncParams.MODELES_IMPRESSION[i].IS_DEFAULT = this.syncParams.MODELES_IMPRESSION[i].IS_DEFAULT == true ? 1 : 0;
        }
      }
      await this._cashDeskRxDbService.db.pmodeleimpression.bulkInsert(this.syncParams.MODELES_IMPRESSION).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.pmodeleimpression.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_PDOSSIER(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_PDOSSIER');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.PDOSSIER ? 1 : 0;
    try {
      if (!!this.syncParams.PDOSSIER.D_RAISONSOC) { this.syncParams.PDOSSIER.D_RAISONSOC = (this.syncParams.PDOSSIER.D_RAISONSOC as string).trim(); }
      await this._cashDeskRxDbService.db.pdossier.bulkInsert([this.syncParams.PDOSSIER]).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.pdossier.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_CHAMPSLIBRE(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_CHAMPSLIBRE');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.CHAMPSLIBRE ? this.syncParams.CHAMPSLIBRE.length : 0;
    try {
      await this._cashDeskRxDbService.db.cbsyslibre.bulkInsert(this.syncParams.CHAMPSLIBRE).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.cbsyslibre.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_MODELES(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_MODELES');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.MODELES ? this.syncParams.MODELES.length : 0;
    try {
      await this._cashDeskRxDbService.db.fmodele.bulkInsert(this.syncParams.MODELES).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fmodele.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_ARTMODELES(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_ARTMODELES');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.ARTMODELES ? this.syncParams.ARTMODELES.length : 0;
    try {
      await this._cashDeskRxDbService.db.fartmodele.bulkInsert(this.syncParams.ARTMODELES).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fartmodele.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_SOUCHESVENTE(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_SOUCHESVENTE');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.SOUCHESVENTE ? this.syncParams.SOUCHESVENTE.length : 0;
    try {
      await this._cashDeskRxDbService.db.psouchevente.bulkInsert(this.syncParams.SOUCHESVENTE).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.psouchevente.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_JOURNAUX(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_JOURNAUX');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.JOURNAUX ? this.syncParams.JOURNAUX.length : 0;
    try {
      await this._cashDeskRxDbService.db.fjournaux.bulkInsert(this.syncParams.JOURNAUX).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.fjournaux.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_BULKINSERT_VXPARAMS(){
    if(!this.syncParams || this.processInError) { return; }
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'BULKINSERT_VXPARAMS');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();
    STEP_ITEM.NB_ITEMS = this.syncParams.VX_PARAMS ? 1 : 0;
    try {
      let _vxParams = this.syncParams.VX_PARAMS;
      let _vxParamsKeys = Object.keys(_vxParams);
      _vxParamsKeys.forEach(key => {
        if(key.endsWith('_PARAMS'))
        {
          _vxParams[key] = JSON.stringify(_vxParams[key]);
        }
      });
      await this._cashDeskRxDbService.db.vxparams.bulkInsert([_vxParams]).then((v) => { console.log(v);
        if(v.error?.length > 0) { this._snackBarService.displayMessage("ERROR", "[" + v.error.length + ' erreurs | ' + v.success.length + ' succès] : ' + STEP_ITEM.TITLE); }
      });
      await this._cashDeskRxDbService.db.vxparams.exportJSON().then((json : any) => {});
      STEP_ITEM.STATUS = 'completed_success';
    }
    catch(err : any){
      this.processInError = true;
      STEP_ITEM.STATUS = 'completed_error';
      STEP_ITEM.ERROR = true;
      STEP_ITEM.ERROR_MESSAGE = err;
      console.log(err);
      this._snackBarService.displayMessage("ERROR", "Erreur [Voir console] : " + STEP_ITEM.TITLE);
    }
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;
  }

  private async runAction_FINALIZE(){
    let STEP_ITEM = this.syncSteps.find(a=> a.CODE == 'FINALIZE');
    STEP_ITEM.STATUS = 'inprogress';
    STEP_ITEM.START = new Date();

    STEP_ITEM.STATUS = 'completed_success';
    STEP_ITEM.END = new Date();
    STEP_ITEM.DURATION = STEP_ITEM.END - STEP_ITEM.START;

    this.syncParams = null;
    this.syncLastDate = new Date();
  }

  private setSessionStorage_DEVICES_LOCALGID(DEVICES : any[]){
    let DEVICES_LOCALGID : any = {};
    DEVICES.forEach((d : any) => {
      if(this.CAISSESESSION_REAFF[d.CAISSE_SESSION!]) { return; }
      else { DEVICES_LOCALGID[d.CAISSE_SESSION] = d.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID; }
    });
    sessionStorage.setItem('DEVICES_LOCALGID', JSON.stringify(DEVICES_LOCALGID));
  }
}
